/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BarcodesWithStockAndProductDetailsViewFactor } from './barcodesWithStockAndProductDetailsViewFactor';
import { BarcodesWithStockAndProductDetailsViewProduct } from './barcodesWithStockAndProductDetailsViewProduct';
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

export interface BarcodesWithStockAndProductDetailsView {
    /**
     * The unique identifier of this record.
     */
    barcodeId?: number;
    barcode?: string;
    /**
     * A reference to the primary key in the Factors Table
     */
    factorId?: number;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    /**
     * A reference to the primary key in the Products Table
     */
    productId?: number;
    organisationId?: string;
    Factor?: BarcodesWithStockAndProductDetailsViewFactor;
    Product?: BarcodesWithStockAndProductDetailsViewProduct;
}
